import React, { FC } from 'react';
import { Dialog, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Radio, useTheme } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { useStyles } from './styles';
import { languages } from '../../utils';
import { CustomDialogTitle } from '../../components';

export interface Props {
  open: boolean;
  translation: any;
  selectedValue: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

export const SelectLanguageDialog: FC<Props> = ({ open, translation, selectedValue, onClose, onChange }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Dialog onClose={onClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.select_language} onClose={onClose} />
      <List dense>
        {languages.map((language) => (
          <ListItem className={classes.languageItem} key={language.value}>
            <ListItemIcon>{language.icon}</ListItemIcon>
            <ListItemText primary={language.label} style={{ textAlign: 'start' }} />
            <ListItemSecondaryAction className={theme.direction === 'rtl' ? classes.languageRadioBtnRtl : classes.languageRadioBtn}>
              <Radio checkedIcon={<CheckCircle htmlColor="#3BBB7A" />} checked={selectedValue === language.label} onChange={() => onChange(language.value)} value={language.value} />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};
